import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import EnterPhoneForm from 'evcharging/containers/ev-rebates/EnterPhoneForm';

const EnterPhone = () => {
  return (
    <Section>
      <Container>
        <EnterPhoneForm />
      </Container>
    </Section>
  );
};

export default EnterPhone;
